import { render, staticRenderFns } from "./DashboardPerformances.vue?vue&type=template&id=dbbb023a"
import script from "./DashboardPerformances.vue?vue&type=script&lang=js"
export * from "./DashboardPerformances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports